import React, {useRef, useState} from 'react';

import classNames from 'classnames';
import CSSModules from 'react-css-modules';

import {Button, LegacyInput} from '@edume/magnificent';

import IntlHeading from '../IntlHeading';

import colourStyles from '../../../../resources/styles/colours.module.scss';
import styles from './styles.module.scss';

interface CopyLinkProps {
  link: string;
  disabled?: boolean;
  inputDisabled?: boolean;
  placeholder?: string;
  inputDataAutomation?: string;
  copyButtonDataAutomation?: string;
  isViewLink?: boolean;
  onCopy?: () => void;
}

const delay = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

const CopyLink = ({
  link,
  disabled,
  inputDisabled,
  placeholder = '',
  inputDataAutomation,
  copyButtonDataAutomation,
  isViewLink,
  onCopy,
}: CopyLinkProps) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const handleOnClickSuccess = async () => {
    setShowSuccess(true);
    await delay(2000);
    setShowSuccess(false);
  };

  const viewLink = async () => {
    window.open(link, '_blank');
    await handleOnClickSuccess();
  };

  const copyLink = async () => {
    navigator.clipboard.writeText(link);
    onCopy?.();
    await handleOnClickSuccess();
  };

  // Maintain button width when clicked
  const ref = useRef<HTMLSpanElement>(null);

  const getDefaultButtonIconUrl = () => {
    if (isViewLink) {
      return undefined;
    }
    return disabled
      ? '/resources/img/24_link_light_grey.svg'
      : '/resources/img/24_link_white.svg';
  };

  const defaultButtonIconUrl = getDefaultButtonIconUrl();

  const defaultButton = (
    <span ref={ref} data-tip data-for='previewTip'>
      <Button
        dataAutomation={copyButtonDataAutomation}
        type={disabled ? 'thirdary' : 'active'}
        disabled={!!disabled}
        onClick={isViewLink ? viewLink : copyLink}
        iconUrl={defaultButtonIconUrl}
        darkIconUrl={defaultButtonIconUrl}
        height='48px'
        noMarginTop
        noMarginLeft
      >
        <IntlHeading
          textKey={`Authoring.label.${isViewLink ? 'view' : 'copy'}EnpsLink`}
          weight='bold'
          size='ant'
          as='legacy-span'
        />
      </Button>
    </span>
  );

  const successButton = (
    <Button
      type='custom'
      onClick={() => {}}
      customColour={colourStyles.successPrimary}
      customDarkColour={colourStyles.successPrimary}
      iconUrl='/resources/img/24_correct_white.svg'
      darkIconUrl='/resources/img/24_correct_white.svg'
      height='48px'
      noMarginTop
      noMarginLeft
    />
  );

  return (
    <div
      styleName={classNames('copy-link-wrapper', {
        disabled,
      })}
    >
      <LegacyInput
        dataAutomation={inputDataAutomation}
        type='text'
        value={link}
        onChangeValue={() => {}}
        placeholder={placeholder}
        validationStyles='hide'
        disabled={disabled || inputDisabled}
        onFocus={(e) => {
          e.select();
          copyLink();
        }}
      />
      <div
        styleName='copy-link-button'
        style={{minWidth: ref.current?.offsetWidth}}
      >
        {showSuccess ? successButton : defaultButton}
      </div>
    </div>
  );
};

export default CSSModules(CopyLink, styles, {allowMultiple: true});
